import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {LoadingService} from "../loading.service";
import {BehaviorSubject, Subscription} from "rxjs";
import {LoadingStatus} from "../../../common-types/loading-status";
import {OrchestrationEvents} from "../../../orchestration/orchestration-events";

@Component({
    selector: "woa-loading-spinner",
    templateUrl: "./loading-spinner.component.html"
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
    private static readonly INDICATOR_DELAY_MS = 500;

    LoadingStatus = LoadingStatus;
    OrchestrationEvents = OrchestrationEvents;

    @Input() showMessages: boolean = false;

    public indicatorVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private subscriptions: Subscription = new Subscription();
    public loading: boolean = false;

    constructor(public changeDetectorRef: ChangeDetectorRef,
                public loadingService: LoadingService) {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.loadingService.loading$.subscribe((loading: boolean) => {
            this.loading = loading;
            if (loading) {
                setTimeout(() => {
                    if (this.loading) {
                        this.indicatorVisible$.next(true);
                    }
                }, LoadingSpinnerComponent.INDICATOR_DELAY_MS);
            } else {
                this.indicatorVisible$.next(false);
            }
            this.changeDetectorRef.detectChanges();
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/loading/loading-spinner/loading-spinner.component.ts